export default "__VITE_ASSET__sRf_BLFI__"